import type { CSSProperties } from "react";

/**
 * SynQUS trademark wordmark — renders inline with consistent branding.
 * "SynQ" in the surrounding text color, "US" in the signature red gradient.
 * Matches the logo wordmark styling exactly (rose-500 → red-600).
 *
 * Usage: <SynqusName /> or <SynqusName size={18} />
 */
interface SynqusNameProps {
  /** Override font size (inherits from parent by default) */
  size?: number;
  /** Additional inline styles */
  style?: CSSProperties;
  className?: string;
}

export default function SynqusName({ size, style, className }: SynqusNameProps) {
  const base: CSSProperties = {
    fontFamily: "'SF Pro Display', 'Inter', -apple-system, sans-serif",
    fontWeight: 800,
    letterSpacing: "-0.03em",
    display: "inline",
    ...(size ? { fontSize: size } : {}),
    ...style,
  };

  return (
    <span className={className} style={base}>
      Syn<span style={{ fontFamily: "'SF Pro Display', 'Inter', -apple-system, sans-serif" }}>Q</span>
      <span
        style={{
          fontFamily: "'Outfit', 'Inter', sans-serif",
          background: "linear-gradient(135deg, #f43f5e, #dc2626)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
        }}
      >
        US
      </span>
    </span>
  );
}
